import request from '@/utils/request'

export default {
  /**
   * 判断是否必须填写台位
   */
  judgeIsMustWriteDesk() {
    return request.get('/customer-prepayment-qr-codes/judge/is-must-write-desk')
  }
}
